import { createFileRoute } from '@tanstack/react-router'
import { UserSecurityPage } from '../../../../components/auth/UserSecurityPage'

// The former Sessions tab, folded into Security (spec 2026-10-01-03). Kept so
// existing links and bookmarks still land on the sessions.
export const Route = createFileRoute('/$org/user/me/sessions')({
    component: UserSessionsRoute,
})

function UserSessionsRoute() {
    const { org } = Route.useParams()
    return <UserSecurityPage org={org} />
}
